import {Component, output} from "@angular/core";
import {SimStatusPalette} from "../../../models/SimStatusPalette";

@Component({
	selector: "sim-numpad",
	templateUrl: "./numpad.component.html",
	styleUrl: "./numpad.component.scss",
	standalone: false,
})
export class NumpadComponent {
	public controls = [1, 2, 3, 4, 5, 6, 7, 8, 9, -1, 0, null];
	protected readonly SimStatusPalette = SimStatusPalette;
	digitClick = output<number>();
	backspaceClick = output<void>();

	protected onDigitClick(digit: number): void {
		this._dispatchKeyboardEvent(digit.toString());
		this.digitClick.emit(digit);
	}

	protected onBackspaceClick(): void {
		this._dispatchKeyboardEvent("Backspace");
		this.backspaceClick.emit();
	}

	private _dispatchKeyboardEvent(key: string): void {
		const event = new KeyboardEvent("keydown", {key});
		window.dispatchEvent(event);
	}
}
